<template>
  <div v-if="$store.state.stringsStore.stringsLoaded" id="app">
    <div v-if="env === 'dev'" class="staging">
        <span>⚠️</span>
        Let op! Je gebruikt de staging-omgeving.
        <span>⚠️</span>
    </div>
    <router-view />
    </div>
</template>

<script>
export default {
  created() {
    if (!this.$store.state.stringsStore.stringsLoaded) {
      this.$store.dispatch('getStrings');
    }
  },
  data() {
    return {
      env: process.env.VUE_APP_ENV,
      stringsLoaded: false,
    };
  },
  mounted() {
    // Text selection does not work when a module loads without first reloading the page.
    window.addEventListener('keydown', (event) => {
      if (event.target.tagName !== 'INPUT' || event.key !== 'a') return;

      const useMetaKey = navigator.platform.indexOf('Mac') > -1;

      // Cmd for mac, ctrl for windows
      const modifier = useMetaKey ? event.metaKey : event.ctrlKey;

      // Select the input text when ctrl+a is pressed
      if (modifier && event.key === 'a') {
        event.target.select();
      }
    });
  },
  destroyed() {
    window.removeEventListener('keydown', () => {});
  },
};
</script>

<style lang="stylus">
body {
  font-family: 'Droid Sans';
}
.staging {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 25px;
    line-height: 25px;
    text-align: center;
    z-index: 9999999;
    background-color: rgba(255, 251, 214, .65);
    border-bottom: 2px solid #fffbd6;
    font-weight bold;
    color: #000;

    span {
        display: block;
        position: absolute;
        top: 0;

        &:nth-child(1) {
            left: 1rem;
        }

        &:nth-child(2) {
            right: 1rem;
        }
    }
}
</style>
